import React from 'react';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import ArticleIcon from '@mui/icons-material/Article';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import Moment from 'moment';
import 'moment/locale/pt-br';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { useTheme } from '@mui/material/styles';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAuth } from '../hooks/useAuth';
import { useQuery } from '../hooks/useQuery';
import { useSnackbar } from '../hooks/useSnackbar';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  cryptedParam,
  encryptData,
  isCnpj,
  serializeQueryString,
} from '../utils';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import Menu from '@mui/material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Pagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import RowCadastro from '../components/RowCadastro';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import SearchOutlined from '@mui/icons-material/SearchOutlined';
import InputMask from 'react-input-mask';
import CustomizedDialogs from '../components/ModalAlert';

let debounce = null;

const ListaCadastroFornededoresPage = () => {
  const theme = useTheme();
  const snackbar = useSnackbar();
  const { user, isUsuarioSebrae } = useAuth();
  const {
    listarCadastrosFornecedores,
    deletarCadastro,
    obterFornecedorPorCnpj,
    verificarFornecedor,
    criarFornecedorDatasul,
  } = useQuery();
  const [fornecedores, setFornecedores] = React.useState([]);
  const datePickerRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [loadingBusca, setLoadingBusca] = React.useState(false);
  const [fornecedor, setFornecedor] = React.useState();
  const [selectedFornecedor, setSelectedFornecedor] = React.useState();
  const [queryParams, setQueryParams] = React.useState({
    nome: '',
    data_abertura: '',
    documento: '',
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState(0);
  const [lastPage, setLastPage] = React.useState(0);
  const [alertProtocol, setAlertProtocol] = React.useState(false);
  const [diffDays, setDiffDays] = React.useState(0);
  const [show, setShow] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [type, setType] = React.useState('success');
  const [isEdit, setIsEdit] = React.useState(false);
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [runRequest, setRunRequest] = React.useState(false);

  React.useEffect(() => {
    listarFornecedoresQuery();
    if (!isUsuarioSebrae) {
      var dateString = user.dt_prot_fornec.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (dateString) {
        var dateObject = new Date(
          dateString[3],
          dateString[2] - 1,
          dateString[1],
        );
        let dataVenc = Moment(dateObject);
        let dataAtual = Moment(new Date());
        let diff = dataVenc.diff(dataAtual, 'days');
        setDiffDays(diff);
        if (diff > 0 && diff <= 15) {
          setAlertProtocol(true);
        }
      }
    }
    const interval = setInterval(() => {
      if (user) {
        listarFornecedoresQuery(1);
      }
    }, 140000);

    return () => clearInterval(interval);
  }, [runRequest]);

  const onClickEdit = (id, status) => {
    navigate(
      `/dashboard/cadastro-fornecedor?fornecedor_id=${encryptData(id)}&step=${
        status == 'PENDÊNCIA' ? 5 : 0
      }`,
    );
  };

  const getfornecedores = async (term) => {
    const newTerm = isCnpj(term) ? term.replace(/[^a-zA-Z0-9]/g, '') : term;

    const result = await obterFornecedorPorCnpj(newTerm);
    if (result && result.data && result.data.data) {
      if (result.data.data.cod_fornec) {
        queryParams.codfornecedor = result.data.data.cod_fornec;
        queryParams.emitente = result.data.data.num_pessoa;
        queryParams.dtProt = result.data.data.dt_prot_fornec;
        queryParams.documento = result.data.data.cnpj_fornec.replace(
          /[^a-zA-Z0-9]/g,
          '',
        );
      }
    }
  };

  const onClickDelete = async (id) => {
    const result = await deletarCadastro(id);
    if (result && result.data) {
      listarFornecedoresQuery(1);
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
    setRunRequest(!runRequest);
  };

  React.useEffect(() => {
    if (user.role_id == 3 || (user.role_id == 2 && !isUsuarioSebrae)) {
      if (
        searchParams.get('fornecedor') == null ||
        searchParams.get('fornecedor') == undefined ||
        searchParams.get('fornecedor') == ''
      ) {
        window.location.href = `/dashboard/listar-cadastros?fornecedor=${
          user.cnpj == null ? user.cpf : user.cnpj
        }`;
      }
    }
  }, []);

  const buscarImportarFornecedor = async () => {
    setLoadingBusca(true);

    try {
      const result = await obterFornecedorPorCnpj(
        fornecedor.replace(/[^a-zA-Z0-9]/g, ''),
      );
      if (result && result.data && result.data.data) {
        const verifyExistDB = await verificarFornecedor(
          fornecedor.replace(/[^a-zA-Z0-9]/g, ''),
        );

        if (
          verifyExistDB &&
          verifyExistDB.data &&
          verifyExistDB.data.data &&
          verifyExistDB.data.data.id
        ) {
          setIsEdit(true);
          setSelectedFornecedor(verifyExistDB.data.data);
          setMessage(
            `O fornecedor ${verifyExistDB.data.data.nome} já possui cadastro no portal, deseja editar?`,
          );
          setShow(true);
        } else {
          setSelectedFornecedor(result.data.data);
          setIsEdit(false);
          setMessage(
            `O fornecedor ${result.data.data.nome_fornec} ainda não possui cadastro no portal, deseja importar?`,
          );
          setShow(true);
        }
      }
    } catch (error) {
      snackbar.showSnackbar('Fornecedor não encontrado');
    } finally {
      setLoadingBusca(false);
    }
  };

  const listarFornecedoresQuery = async (pagina = 1) => {
    try {
      // if (!queryParams.cnpj) return;
      setLoading(true);
      if (searchParams.get('fornecedor')) {
        queryParams.paginate = false;
        if (!isUsuarioSebrae) {
          if (user.tipo_pessoa === 'PF') {
            if (searchParams.get('fornecedor') == user.cpf) {
              queryParams.fornecedor = searchParams.get('fornecedor');
            } else {
              queryParams.fornecedor = user.cpf;
            }
          } else {
            if (searchParams.get('fornecedor') == user.cnpj) {
              queryParams.fornecedor = searchParams.get('fornecedor');
            } else {
              queryParams.fornecedor = user.cnpj ? user.cnpj : user.cpf;
            }
          }
        } else {
          queryParams.fornecedor = searchParams.get('fornecedor');
        }

        try {
          await getfornecedores(user.cnpj);
          const result = await listarCadastrosFornecedores(
            serializeQueryString(queryParams),
          );

          console.log('result', result);
          setFornecedores(result.data.data.data);
        } catch (error) {
          const result = await listarCadastrosFornecedores(
            serializeQueryString(queryParams),
          );
          setFornecedores(result.data.data.data);

          if (result.data.data.data.length > 0) {
            const f = result.data.data.data[0];

            if (f.status === 'RASCUNHO') {
              onClickEdit(f.id, f.status);
            }
          }
        }
      } else {
        queryParams.paginate = true;
        queryParams.page = page;
        const result = await listarCadastrosFornecedores(
          serializeQueryString(queryParams),
        );
        setFornecedores(result.data.data.data);
        setPage(result.data.data.current_page);
        setLastPage(result.data.data.last_page);
        setTotal(result.data.data.total);
      }
    } catch (error) {
      snackbar.showSnackbar(error.toString());
    } finally {
      setLoading(false);
    }
  };

  const handleButtonOk = async () => {
    if (isEdit) {
      setShow(false);
      navigate(
        `/dashboard/cadastro-fornecedor?fornecedor_id=${encryptData(
          selectedFornecedor.id,
        )}`,
      );
    } else {
      setLoadingBusca(true);
      setShow(false);
      let result = await criarFornecedorDatasul({
        codfornecedor: selectedFornecedor.cod_fornec,
        emitente: selectedFornecedor.num_pessoa,
        dtProt: selectedFornecedor.dt_prot_fornec,
        documento: selectedFornecedor.cnpj_fornec.replace(/[^a-zA-Z0-9]/g, ''),
      });
      if (result && result.data && result.data.data) {
        listarFornecedoresQuery(1);
        snackbar.showSnackbar('Cadastro importado com sucesso!');
      }
      setLoadingBusca(false);
    }
  };

  return (
    <Box
      mt={8}
      sx={{ width: '100%', background: '#FAFCFF', minHeight: '100vh' }}
    >
      <AppBar position="static" color="primary" style={{ padding: 10 }}>
        <Grid container spacing={0}>
          <Grid item display="flex" alignItems="center">
            <ArticleIcon
              sx={{
                fontSize: 40,
              }}
            />
            <span style={{ color: 'white', fontSize: 20 }}>
              Cadastro de Fornecedor
            </span>
          </Grid>
        </Grid>
      </AppBar>
      <CustomizedDialogs
        content={message}
        btnTxt={'Ok'}
        type={type}
        onClick={handleButtonOk}
        handleClose={() => setShow(false)}
        visible={show}
      />
      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        {alertProtocol ? (
          <Grid item sm={12}>
            <Stack sx={{ width: '100%' }} spacing={2}>
              <Alert severity="error">
                Falta {diffDays} dias para o vencimento do seu cadastro. Favor
                realizar a atualização dos dados cadastrais.
              </Alert>
            </Stack>
          </Grid>
        ) : null}
        {isUsuarioSebrae ||
        (user && user.role_id == 6 && user.cod_usuario != '') ? (
          <Grid item sm={6} display="flex" justifyContent="flex-end">
            <InputMask
              style={{ marginTop: '5px' }}
              mask="**.***.***/****-**"
              maskChar={''}
              value={fornecedor}
              onChange={(event) => {
                setFornecedor(event.target.value);
              }}
            >
              {(inputProps) => (
                <TextField
                  style={{
                    width: '100%',
                    marginBottom: '0.8rem',
                    marginRight: 10,
                  }}
                  id="outlined-basic"
                  label="Buscar e importar fornecedor por CNPJ"
                  variant="outlined"
                />
              )}
            </InputMask>
            <Button
              onClick={() => {
                buscarImportarFornecedor();
              }}
              style={{ height: 38 }}
              variant="contained"
              startIcon={
                loadingBusca ? (
                  <CircularProgress style={{ height: 10, width: 10 }} />
                ) : (
                  <SearchOutlined />
                )
              }
            >
              Buscar
            </Button>
          </Grid>
        ) : null}
        {isUsuarioSebrae ||
        (user && user.role_id == 6 && user.cod_usuario != '') ? (
          <Grid item sm={6} display="flex" justifyContent="flex-end">
            <Button
              onClick={() => {
                navigate(`/dashboard/cadastro-fornecedor`);
              }}
              variant="contained"
              startIcon={<AddIcon />}
            >
              Novo Cadastro
            </Button>
          </Grid>
        ) : null}
      </Grid>
      <Grid
        container
        padding={2}
        direction={{ xs: 'column-reverse', md: 'row', lg: 'row' }}
      >
        <Grid
          item
          xs={12}
          width="100%"
          md={
            isUsuarioSebrae ||
            (user && user.role_id == 6 && user.cod_usuario != '')
              ? 9
              : 12
          }
        >
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress style={{ marginTop: 60 }} />
            </Box>
          ) : (
            <div
              style={{
                width: '100%',
                overflowX: 'scroll',
                overflowY: 'hidden',
              }}
            >
              <table className="app_table">
                <thead
                  style={{
                    color: theme.palette.primary.main,
                    borderTop: `8px solid ${theme.palette.primary.light}`,
                  }}
                >
                  <tr>
                    <th style={{ width: '20%' }}>Nome</th>
                    <th style={{ width: '10%' }}>Fluig</th>
                    <th style={{ width: '15%' }}>Data de abertura</th>
                    <th style={{ width: '15%' }}>Data Vencimento Cadastro</th>
                    <th style={{ width: '15%' }}>Documento</th>
                    <th style={{ width: '20%' }}>Status</th>
                  </tr>
                </thead>

                <tbody>
                  {fornecedores.map((fornecedor, index) => (
                    <RowCadastro
                      fornecedor={fornecedor}
                      index={index}
                      onClickDelete={onClickDelete}
                      onClickCancel={listarFornecedoresQuery}
                      onClickEdit={onClickEdit}
                    />
                  ))}
                  {!loading && fornecedores && fornecedores.length == 0 ? (
                    <tr>
                      <td colSpan={5} align="center">
                        Nenhum cadastro encontrado.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          )}
          <Box
            marginTop={5}
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Pagination
              count={lastPage}
              page={page}
              color={'primary'}
              onChange={handleChange}
            />
          </Box>
        </Grid>
        {isUsuarioSebrae ||
        (user && user.role_id == 6 && user.cod_usuario != '') ? (
          <Grid
            item
            sm={3}
            sx={{
              paddingLeft: { xs: 2 },
              paddingRight: { xs: 2 },
            }}
          >
            <Card
              variant="outlined"
              style={{
                borderTop: `8px solid ${theme.palette.primary.light}`,
              }}
            >
              <CardContent>
                <p
                  style={{
                    color: '#0e72b8',
                    marginTop: 0,
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <FilterAltIcon color="primary" />
                  Filtro
                </p>
                <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>
                  Fornecedor
                </p>
                <TextField
                  style={{ width: '100%', marginBottom: '0.8rem' }}
                  id="outlined-basic"
                  label="Fornecedor"
                  value={queryParams.nome}
                  onChange={({ target }) =>
                    setQueryParams({ ...queryParams, nome: target.value })
                  }
                  variant="outlined"
                />

                <p style={{ color: '#0e72b8', fontWeight: 'bold' }}>
                  Documento
                </p>
                <TextField
                  style={{ width: '100%', marginBottom: '0.8rem' }}
                  id="outlined-basic"
                  label="Digite CPF/CNPJ"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .substring(0, 14)
                      .replace(/[^a-zA-Z0-9]/g, '')
                      .toUpperCase();
                  }}
                  inputProps={{
                    min: 0,
                    maxLength: 16,
                  }}
                  value={queryParams.documento}
                  onChange={({ target }) =>
                    setQueryParams({ ...queryParams, documento: target.value })
                  }
                  variant="outlined"
                />
                <Button
                  variant="contained"
                  onClick={listarFornecedoresQuery}
                  style={{ width: '100%', marginTop: 20 }}
                >
                  Buscar
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setQueryParams({
                      nome: '',
                      documento: '',
                    });
                    setRunRequest(!runRequest);
                  }}
                  style={{ width: '100%', marginTop: 20 }}
                >
                  Limpar
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
};

export default ListaCadastroFornededoresPage;
